import { FC } from 'react';
import { Route, Routes } from 'react-router-dom';
import useSWR from 'swr';
import User from 'types/User';
import NotFound from '../../not-found';
import Redirect from '../../redirect';
import Documents from './documents';
import EditFormMentor from './edit-form';
import MentorshipManagement from './management';
import SuggestGeneralInterview from './management/interviews/suggest';
import ReviewPage from './management/interviews/[id]';
import Edit from './management/interviews/[id]/edit';
import MenteeDetails from './management/mentees/[id]/index';
import SuggestMenteeInterview from './management/mentees/[id]/interviews/suggest';
import MentorMessaging from './messaging';
import SignChart from './sign-chart';
import Training from './training';

const MentorshipRoutes: FC = () => {
  const { data: user } = useSWR<User>('/auth/profile');
  return (
    <Routes>
      <Route
        path="/"
        element={<Redirect href="/mentor/mentorship/edit-form" />}
      />
      <Route path="/edit-form" element={<EditFormMentor />} />
      <Route path="/sign-chart" element={<SignChart />} />
      {user?.mentorStatus !== 'FILLING_FORM' &&
        user?.mentorStatus !== 'SIGNING_CHART' && (
          <Route path="/confirm-training" element={<Training />} />
        )}
      <Route path="/messaging/*" element={<MentorMessaging />} />

      <Route
        path="/management/mentees/details/:id/interviews/suggest"
        element={<SuggestMenteeInterview />}
      />
      <Route
        path="/management/mentees/details/:id/*"
        element={<MenteeDetails />}
      />
      <Route
        path="/management/interviews/suggest"
        element={<SuggestGeneralInterview />}
      />
      <Route path="/management/interviews/:id" element={<ReviewPage />} />
      <Route path="/management/interviews/:id/edit" element={<Edit />} />
      <Route path="/management/*" element={<MentorshipManagement />} />
      <Route path="/documents" element={<Documents />} />
      <Route path="/*" element={<NotFound />} />
    </Routes>
  );
};

export default MentorshipRoutes;
